export const AnchorLink = ({ children, href, className, title, onClick }) => {
	const renderChildren = () => {
		if (title) {
			return title;
		}
		if (children) {
			return children;
		}
		return 'anchor';
	};

	return (
		<a
			target="_blank"
			rel="noreferrer"
			href={href}
			className={className}
			onClick={onClick}>
			{renderChildren()}
		</a>
	);
};
